import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/components/pages/Home';
import Start from '@/components/pages/Start';
import StartFromCode from '@/components/pages/Start.FromCode';
import StartBloodSugar from '@/components/pages/Start.BloodSugar';
import StartMeals from '@/components/pages/Start.Meals';
import StartLocation from '@/components/pages/Start.Location';
import StartCalendar from '@/components/pages/Start.Calendar';
import Dashboard from '@/components/pages/Dashboard';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/start',
      name: 'Start',
      component: Start,
    },
    {
      path: '/start/from-code',
      name: 'StartFromCode',
      component: StartFromCode,
    },
    {
      path: '/start/blood-sugar',
      name: 'StartBloodSugar',
      component: StartBloodSugar,
    },
    {
      path: '/start/meals',
      name: 'StartMeals',
      component: StartMeals,
    },
    {
      path: '/start/location',
      name: 'StartLocation',
      component: StartLocation,
    },
    {
      path: '/start/calendar',
      name: 'StartCalendar',
      component: StartCalendar,
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});



// WEBPACK FOOTER //
// ./src/router/index.js